export default {
  namespaced: true,
  state: {
    roles: [],
    contractTypes: [],
    skills: [],
    salary: null,
    noticePeriod: null,
    resumeRequired: false
  },
  getters: {
    data: state => {
      const data = {}
      if (state.roles.length > 0) { data.roles = state.roles }
      if (state.contractTypes.length > 0) {
        data.contractTypes = state.contractTypes
      }
      if (state.skills.length > 0) {
        data.skills = state.skills
      }
      if (state.salary) { data.salary = state.salary }
      if (state.noticePeriod) { data.noticePeriodInDays = state.noticePeriod }
      if (state.resumeRequired) { data.resume = state.resumeRequired }
      return data
    }
  },
  mutations: {
    clear (state) {
      state.roles = []
      state.contractTypes = []
      state.skills = []
      state.salary = null
      state.noticePeriod = null
      state.resumeRequired = false
    },
    setRoles (state, roles) {
      state.roles = roles
    },
    setContractTypes (state, contractTypes) {
      state.contractTypes = contractTypes
    },
    setSkills (state, skills) {
      state.skills = skills
    },
    setSalary (state, salary) {
      state.salary = salary
    },
    setNoticePeriod (state, noticePeriod) {
      state.noticePeriod = noticePeriod
    },
    setResumeRequired (state, required) {
      state.resumeRequired = required
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/jobseekers-filter.js